import React, { useState } from "react";
import { Button, Stack, styled } from "@mui/material";
import { CloudUploadOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";
import useImageUpload from "../../../../hooks/useImageUpload";
import { imageCreate, imageUploadImage } from "../../../../api/image";
import ImageModal from "../../../helpers/ImageModal";

const StyledStack = styled(Stack)`
  flex-direction: row;
  justify-content: end;
  margin-bottom: 1.5em;
`;

const ImageCreateButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const infoSnackbar = useInfoSnackbar();
  const imageUploadObj = useImageUpload();
  const navigate = useNavigate();

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const handleImageSave = async () => {
    if (imageUploadObj.selectedImage !== null) {
      try {
        const newImageDataRes = await imageCreate({
          imageName: "",
          imageCredit: "",
          imageLabel: "",
          imageType: "",
          imageUrl: "",
        });
        if (newImageDataRes.code === "ERROR") {
          throw (new Error(newImageDataRes.message));
        }
        const newImageUploadRes = await imageUploadImage(
          imageUploadObj.selectedImage,
          newImageDataRes.data.imageEntityId,
          imageUploadObj.handleUploadProgress,
        );
        if (newImageUploadRes.code === "SUCCESS") {
          infoSnackbar.alertSuccess(newImageUploadRes.message);
          navigate(`${newImageDataRes.data.imageEntityId}/update`);
        } else throw new Error(newImageUploadRes.message);
      } catch {
        infoSnackbar.alertError("Something went wrong...");
      }
    }
    imageUploadObj.reset();
  };

  return (
    <>
      <StyledStack>
        <Button
          variant="contained"
          component="label"
          startIcon={<CloudUploadOutlined/>}
          onClick={handleModalOpen}
        >
          New
        </Button>
      </StyledStack>
      <ImageModal
        imageUrl={null}
        modalOpen={modalOpen}
        onModalClose={handleModalClose}
        onNewImageConfirmed={handleImageSave}
        imageUploadObj={imageUploadObj}
      />
    </>
  );
};

export default ImageCreateButton;